<template>
  <RevContainer>
    <div class="flex items-center justify-between">
      <div class="caption-bold py-8">
        <div class="flex h-full items-center gap-24">
          <RevLink
            v-for="{ label, name, url, icon, classNames } in links"
            :key="name"
            class="flex items-center gap-4"
            data-test="footer-link"
            :to="url"
            :tracking="{ name: name, zone: 'header' }"
            :underlined="false"
          >
            <component
              :is="icon"
              v-if="icon"
              :class="[classNames, 'h-16 w-16']"
            />
            <span :class="classNames">
              {{ label }}
            </span>
          </RevLink>
        </div>
      </div>

      <div class="flex items-center gap-8">
        <DeliveryPostalCodeTrigger
          v-if="isPostalCodePromiseEnabled"
          entry-point="nav"
          link-size="compact"
          tracking-context="web"
        />
        <DeliveryPostalCodeModal
          v-if="isPostalCodePromiseEnabled"
          entry-point="nav"
          tracking-context="web"
        />
        <CountrySwitchMenu :compact="showLanguageSwitchLinks" />
        <LanguageSwitchLinks v-if="showLanguageSwitchLinks" />
      </div>
    </div>
  </RevContainer>
</template>

<script setup lang="ts">
import { useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevContainer } from '@ds/components/Container'
import { RevLink } from '@ds/components/Link'

import DeliveryPostalCodeModal from '~/scopes/shipping/components/DeliveryPostalCodeModal/DeliveryPostalCodeModal.vue'
import DeliveryPostalCodeTrigger from '~/scopes/shipping/components/DeliveryPostalCodeModal/DeliveryPostalCodeTrigger.vue'

import { useNavLinks } from '../../../composables/useNavLinks'
import CountrySwitchMenu from '../../CountrySwitch/CountrySwitchMenu.vue'
import LanguageSwitchLinks from '../../CountrySwitch/LanguageSwitchLinks.vue'

const { links } = useNavLinks({ withBuyback: false, variant: 'small' })
const experiments = useExperiments()

const isPostalCodePromiseEnabled = computed(
  () => experiments['experiment.postalCodePromise'] === 'postalCodeEnabled',
)

const {
  public: { FF_ENABLE_LANGUAGE_SWITCH_LINKS_HEADER },
} = useRuntimeConfig()
const { market } = useMarketplace()

const showLanguageSwitchLinks = FF_ENABLE_LANGUAGE_SWITCH_LINKS_HEADER?.split(
  ',',
).includes(market.countryCode)
</script>
